import React, {Component, Fragment} from 'react';
import {Card, Form, FormFeedback, FormGroup, Label} from 'reactstrap';
import withValidator from '../../models/form/withValidator';
import LoadingButton from '../../../shared/ui/LoadingButton';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  
  fields: {
    content: {
      rules: [
        {
          feedback: 'Content is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class HeaderFormCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: { content: '' },
      dropdownOpen: false,
      errorFeedback: {},
      isFormDisabled: true,
      content: !this.props.initialValues
        ? ''
        : this.props.initialValues.content,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({ content: this.state.content });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value, true);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit() {
    const properties = { content: this.state.content };
    this.props.onSave(properties);
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <Card className="mb-3">
          <Form
            className="m-3"
            noValidate
            onSubmit={event => this.handleSubmit(event)}
          >
            <FormGroup>
              <Label for="content">Content *</Label>
              <textarea
                rows={10}
                className="form-control"
                id="content"
                name="content"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Header"
                value={this.state.content}
              >
              </textarea>
              {/*<Input*/}
              {/*  className={this.state.cssValidationClasses.content}*/}
              {/*  type="textarea"*/}
              {/*  id="content"*/}
              {/*  name="content"*/}
              {/*  onBlur={event => this.handleBlur(event)}*/}
              {/*  onChange={event => this.handleInput(event)}*/}
              {/*  placeholder="Header"*/}
              {/*  value={this.state.content}*/}
              {/*/>*/}
              <FormFeedback>{this.state.errorFeedback.content}</FormFeedback>
            </FormGroup>
          </Form>
          <div className="mb-3 ml-3">
            <LoadingButton
              primary
              text="Submit"
              isLoading={this.props.isLoading}
              disabled={this.state.isFormDisabled}
              onClick={event => this.handleSubmit(event)}
            />
          </div>
        </Card>
      </Fragment>
    );
  }
}

export default withValidator(HeaderFormCard, validatorConfig);
